export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect width="64" height="64" rx="16" fill="#070B14" stroke="rgba(255,255,255,0.12)" />
    <path d="M14 47V20l18 16 18-16v27" fill="none" stroke="#00E5FF" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M52 6l2.2 5.8L60 14l-5.8 2.2L52 22l-2.2-5.8L44 14l5.8-2.2z" fill="#F8FAFC" className="mm-sparkle" />
  </svg>
);

export const Logo = () => (
  <span className="flex items-center gap-3">
    <LogoMark />
    <span className="font-display text-[15px] font-bold leading-none tracking-tight text-white">
      Mister<span className="text-[var(--cyan)]">.</span>
      <span className="block text-[11px] font-mono font-medium uppercase tracking-[0.25em] text-slate-400">Multiservice</span>
    </span>
  </span>
);
